import { Panel } from "@/components/app/common";
import { useFetch } from "@/hooks/useFetch";

const Items = ({ items, tone }) => (
  <ul className="text-xs space-y-0.5">{items.map((x) => <li key={x.endpoint} className={tone}><span className="font-mono">{x.endpoint}</span> <span className="text-slate-500">({x.action}{x.after ? ` · needs ${x.after}` : ""})</span></li>)}</ul>
);

// Built-in permission rules in this app version vs the baseline of the last approved publish
export function PermissionRulesReport() {
  const { data: r, loading } = useFetch("/admin/permission-rules-report");
  if (loading || !r) return <p className="text-sm text-slate-500">Checking all permission rules…</p>;
  const clean = !r.changed_rules.length;
  return (
    <div className="space-y-4" data-testid="perm-rules-report">
      <div className={`rounded border px-4 py-3 text-sm ${clean ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-amber-300 bg-amber-50 text-amber-900"}`} data-testid="perm-rules-status">
        {clean ? `No built-in permission rule changes in this version - all ${r.routes} endpoints behave as at the last approved publish. Safe to publish from a permissions point of view.`
          : `${r.changed_rules.length} endpoint rule(s) differ from the last approved publish. Check the role changes below before publishing.`}
        {!r.baseline_found && " (No baseline found - every endpoint shows as new.)"}
      </div>
      {r.roles.map((x) => (
        <Panel key={x.key} title={`${x.role} · ${x.users_count} active user(s)`} testid={`perm-rules-role-${x.key}`}>
          <div className="grid md:grid-cols-2 gap-4">
            <div><div className="text-xs font-semibold uppercase text-emerald-700 mb-1">Gains ({x.gained.length})</div>{x.gained.length ? <Items items={x.gained} tone="text-emerald-800" /> : <p className="text-xs text-slate-400">Nothing</p>}</div>
            <div><div className="text-xs font-semibold uppercase text-red-700 mb-1">Loses ({x.lost.length})</div>{x.lost.length ? <Items items={x.lost} tone="text-red-800" /> : <p className="text-xs text-slate-400">Nothing</p>}</div>
          </div>
        </Panel>
      ))}
      {!clean && !r.roles.length && <p className="text-xs text-slate-500">The changed rules do not change access for any current role.</p>}
    </div>
  );
}
